import React from "react";
import { Minus, Plus } from "lucide-react";

export function QuantityStepper({ value, onChange, min = 1, max = 99, size = "md", testIdPrefix }) {
  const btn = size === "sm" ? "h-8 w-8" : "h-12 w-12";
  const icon = size === "sm" ? 12 : 15;
  const tid = (s) => (testIdPrefix ? `${testIdPrefix}-quantity-${s}` : undefined);
  return (
    <div className="flex items-center border border-border">
      <button type="button" onClick={() => onChange(Math.max(min, value - 1))} data-testid={tid("decrement")} className={`grid ${btn} place-items-center hover:text-gold`} aria-label="Decrease quantity">
        <Minus size={icon} />
      </button>
      <span className={`${size === "sm" ? "w-8" : "w-10"} text-center text-sm`} data-testid={tid("value")}>{value}</span>
      <button type="button" onClick={() => onChange(Math.min(max, value + 1))} data-testid={tid("increment")} className={`grid ${btn} place-items-center hover:text-gold`} aria-label="Increase quantity">
        <Plus size={icon} />
      </button>
    </div>
  );
}
